import { translated } from "./i18n";

/**
 * Fixed referentials mirrored from the backend (`ada/reference.py`, `ada/models.py`). The TRL
 * label also comes with every project payload (`trl_label`); this copy serves the pickers.
 */
export const TRL_LABELS: Record<number, string> = translated({
  1: "Basic principles observed",
  2: "Technology concept formulated",
  3: "Experimental proof of concept",
  4: "Technology validated in lab",
  5: "Technology validated in relevant environment",
  6: "Technology demonstrated in relevant environment",
  7: "System prototype demonstrated in operational environment",
  8: "System complete and qualified",
  9: "Actual system proven in operational environment",
});

export const TRL_LEVELS = [1, 2, 3, 4, 5, 6, 7, 8, 9] as const;

export function trlLabel(level: number): string {
  return TRL_LABELS[level] ?? "";
}

/** ISO weekday (1 = Monday) → name, as the settings store it. */
export const WEEKDAYS: Record<number, string> = translated({
  1: "Monday",
  2: "Tuesday",
  3: "Wednesday",
  4: "Thursday",
  5: "Friday",
  6: "Saturday",
  7: "Sunday",
});

/** Fallback copy of `REPORT_FIELDS`, used until the week context answers (and outside French). */
export const REPORT_FIELD_DEFAULTS = {
  done: translated({ label: "Done", help: "What was done on the project this week." }),
  next: translated({ label: "Planned", help: "What is planned for the following week." }),
  blockers: translated({ label: "Points of attention", help: "Blockers, risks, needs (optional)." }),
  absent: translated({ label: "Absent / no activity", help: "Checked: the section counts as filed." }),
};
